// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { action, computed, set, get } from '@ember/object';

/**
 * @param {Function}              onUpdate
 * @param {Array<Flow>}           visitorTypes
 * @param {Function}              loadVisitorTypes
 */
export default class VisitorTypes extends Component {
  tagName = '';

  // Need to explicitly notify that visitorTypes changed when idScanPage is changed
  // Automatic notification through each async relation does not update
  @computed('visitorTypes.@each.{idScanPage,isGlobalChild}')
  get enabledValues() {
    const flows = this.visitorTypes && this.visitorTypes.length ? this.visitorTypes : [];
    // Only consider non-global flows — globals are read-only and shouldn't
    // affect whether Select all / Deselect all links appear, since those
    // links only act on non-global flows.
    return flows
      .filter((vt) => !vt.isGlobalChild)
      .map((vt) => get(vt, 'idScanPage.enabled'))
      .uniq();
  }

  @computed('enabledValues')
  get allSelected() {
    return this.enabledValues.length === 1 && this.enabledValues[0] === true;
  }

  @computed('enabledValues')
  get noneSelected() {
    return this.enabledValues.length === 1 && this.enabledValues[0] === false;
  }

  // Whether the user has any toggleable (non-global) visitor types. Drives
  // whether Select all / Deselect all links should be shown — when false,
  // both links would be no-ops, so they're hidden.
  @computed('visitorTypes.@each.isGlobalChild')
  get hasNonGlobalFlows() {
    const flows = this.visitorTypes && this.visitorTypes.length ? this.visitorTypes : [];
    return flows.some((vt) => !vt.isGlobalChild);
  }

  @action
  deselectAll() {
    this.visitorTypes.forEach((vt) => {
      // Global visitor types are managed at the global overview and are
      // read-only here, so skip them when bulk-toggling.
      if (vt.isGlobalChild) return;
      set(vt, 'idScanPage.enabled', false);
    });
    this.triggerUpdated();
  }

  @action
  selectAll() {
    this.visitorTypes.forEach((vt) => {
      // Global visitor types are managed at the global overview and are
      // read-only here, so skip them when bulk-toggling.
      if (vt.isGlobalChild) return;
      set(vt, 'idScanPage.enabled', true);
    });
    this.triggerUpdated();
  }

  @action
  toggleEnabled(visitorType) {
    // Defense in depth: the checkbox is already disabled in the template for
    // globals, but guard the action too so programmatic or future callers
    // can't mutate a read-only flow.
    if (visitorType.isGlobalChild) return;
    set(visitorType, 'idScanPage.enabled', !get(visitorType, 'idScanPage.enabled'));
    this.triggerUpdated();
  }

  triggerUpdated() {
    // eslint-disable-next-line ember/classic-decorator-no-classic-methods
    this.notifyPropertyChange('visitorTypes');
    this.onUpdate({ hasChanges: true });
  }
}
